module.exports = __webpack_public_path__ + "static/media/Jocelyn Moffatt.f55fe08f.png";